import { useState } from 'react';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import BeforeAfter from './components/BeforeAfter';
import Benefits from './components/Benefits';
import Registration from './components/Registration';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <HowItWorks />
      <BeforeAfter />
      <Benefits />
      <Registration />
      <Contact />
      <Footer />
    </div>
  );
}
